import React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import api from '../services/api';
import { useFormik } from 'formik';
import * as Yup from 'yup';

export default function FormDialog() {
  const [openDialogInsertEmail, setOpenDialogInsertEmail] = React.useState(false);
  const [openDialogMsg, setOpenDialogMsg] = React.useState(false);

  async function handleEmail(e) {
    try {
      await api.get('/users/forgotpass', { params: { email: formik.values.email } });
      setOpenDialogMsg(true);
    } catch (err) {
      alert('Erro no envio do email! Tente novamente');
    }
  }

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email('Insira um email valido').required('Campo Obrigatório'),
    }),
    onSubmit: (values) => {
      handleEmail(values);
    },
  });

  const handleClickOpen = () => {
    setOpenDialogInsertEmail(true);
  };

  const handleClose = () => {
    setOpenDialogInsertEmail(false);
  };

  return (
    <div>
      <Button color="primary" onClick={handleClickOpen}>
        Esqueceu sua senha?
      </Button>

      <Dialog open={openDialogInsertEmail} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Insira seu email de cadastro para recuperação de senha:</DialogTitle>
        <DialogContent>
          {/* <DialogContentText>
            Insira seu email de cadastro para recuperação de senha:
          </DialogContentText> */}
          <form onSubmit={formik.handleSubmit}>
            <TextField
              autoFocus
              margin="dense"
              id="email"
              label="Email"
              type="email"
              fullWidth
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={!!(formik.touched.email && formik.errors.email)}
              helperText={
                              formik.touched.email
                              && formik.errors.email
                              && formik.errors.email
                            }
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button className="button" color="primary" onClick={formik.handleSubmit}>
            Submeter
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openDialogMsg} onClose={() => setOpenDialogMsg(false)} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Uma mensagem com o token de reinicialização de senha foi enviado ao seu email. Por favor, verifique seu email para prosseguir com a operação.</DialogTitle>
        <DialogContent />
        <DialogActions>
          <Button
            onClick={() => {
              setOpenDialogMsg(false);
              setOpenDialogInsertEmail(false);
            }}
            color="primary"
          >
            Entendi
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
